import LandingLayout from '@/components/layouts/LandingLayout';
import DefaultTemplate from '@/components/templates/Default';
import fire from '@/utils/firebase';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

export default function Home({ socialData }: any) {
  return (
    <DefaultTemplate>
      <LandingLayout socialFeedback={socialData} />
    </DefaultTemplate>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const faq = await fire
    .firestore()
    .collection(`website`)
    .doc(`main`)
    .collection(`social`)
    .get();

  const SECONDS_IN_A_DAY = 84_400;
  return {
    props: {
      socialData: faq.docs.map((item) => ({ id: item.id, ...item.data() })),
      ...(await serverSideTranslations(locale as string, [
        `common`,
        `landing`,
      ])),
    },
    revalidate: SECONDS_IN_A_DAY,
  };
};
